import { FilterState, Selection } from "../DataTable/DataTable";
import { useClubSlug } from "../Clubs/hooks";
import { useApi } from "../../hooks/useApi";
import { useCallback, useMemo, useState } from "react";
import { Form } from "@form/Form";
import { FormInput } from "@form/index";
import { FieldValues } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Blockquote } from "@ui";
import useSWR from "swr";
import { ClubMemberProperty } from "./types";
import useFileDownload from "../../hooks/useFileDownload";

interface Props {
    filter?: FilterState;
    members: Selection;
    callback?: () => void;
}

const LetterComponent = ({ filter, members, callback }: Props) => {
    const { t } = useTranslation("member-management");
    const clubSlug = useClubSlug();
    const api = useApi();
    const download = useFileDownload();
    const [isLoading, setIsLoading] = useState(false);
    const { data: propertyData } = useSWR<{ data: ClubMemberProperty[] }>(`club-member/${clubSlug}/property`);

    const handleSubmit = useCallback((data: FieldValues) => {
        setIsLoading(true);
        return api({
            url: `club-member/${clubSlug}/letters`,
            method: "POST",
            data: { filter, members, ...data },
            muted: true,
            onBefore: () => setIsLoading(false),
            onSuccess: (data) => {
                download(data.download_id);
                callback?.();
            }
        });
    }, [clubSlug, callback, members, filter]);

    const placeholders = useMemo(() => [{ name: "firstname", title: t('letter.placeholders.firstname') }, {
        name: "lastname",
        title: t('letter.placeholders.lastname')
    }, { name: "gender", title: t('letter.placeholders.gender') }, { name: "email", title: t('letter.placeholders.email') }, {
        name: "address",
        title: t('letter.placeholders.address')
    }, { name: "group", title: t('letter.placeholders.group') }, { name: "category", title: t('letter.placeholders.category') }, {
        name: "remarks",
        title: t('letter.placeholders.remarks')
    }, { name: "entry_date", title: t('letter.placeholders.entryDate') }, { name: "exit_date", title: t('letter.placeholders.exitDate') }, {
        name: "ads",
        title: t('letter.placeholders.ads')
    }, { name: "birthday", title: t('letter.placeholders.birthday') }, { name: "phone", title: t('letter.placeholders.phone') }, {
        name: "created_at",
        title: t('letter.placeholders.createdAt')
    }, ...(propertyData?.data?.map(({ key, title }) => ({ name: key, title })) || [])], [propertyData, t]);

    return <div>
        {typeof members === "object" && members.length > 0 && <Blockquote>
            {t('letter.selectionInfo')}
        </Blockquote>}
        <Form onSubmit={handleSubmit} setDefaultValuesOnRerender={false} defaultValues={{ date: new Date() }}>
            <FormInput.DatePicker name="date" label={t('letter.dateLabel')} />
            <FormInput name="subject" label={t('letter.subjectLabel')} />
            <FormInput.WYSIWYG placeholders={placeholders} name="message" label={t('letter.messageLabel')} />
            <FormInput.Submit isLoading={isLoading}>{t('letter.submit')}</FormInput.Submit>
        </Form>
    </div>;
};

export default LetterComponent;